const RestoreWebpageColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: '80px'
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url',
    slot: 'webpageUrl'
  },
  {
    title: 'Previous Plan',
    dataIndex: 'plan_type',
    slot: 'planType'
  },
  {
    title: 'Previous Polling Interval',
    dataIndex: 'polling_interval',
    slot: 'pollingInterval'
  }
];

export { RestoreWebpageColumns };
